import * as React from 'react'

function SvgUserAccountDesktopHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 1441 323" fill="none" {...props}>
      <path
        d="M1440 9.05v517.026H0l-.001-133.891s401.352-259.11 829.605-339.877C1257.86-28.46 1440 9.05 1440 9.05z"
        fill="url(#prefix__paint0_radial_user_account_desktop_hero_bg)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_user_account_desktop_hero_bg"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(592.58201 -1097.66947 2071.33514 1118.22 339.611 1005.33)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgUserAccountDesktopHeroBG
